import Dependencies from './Dependencies';

export default Dependencies;
